import PropTypes from 'prop-types';

const displayName = 'UnavailablePage';
const propTypes = {
  onClick: PropTypes.func,
  description: PropTypes.object,
  isUnauthorized: PropTypes.bool,
};
const defaultProps = {
  onClick: () => {},
  description: {},
  isUnauthorized: false,
};

export default { displayName, propTypes, defaultProps };
